import { Component, OnInit } from '@angular/core';
import { User } from '../../models/user';
import { Account } from '../../models/account';
import { Router } from '@angular/router';

import { UserService } from '../../services/user.service'
import {AccountService} from "../../services/account.service";

@Component({
    selector: 'user-list',
    templateUrl: 'user-list.component.html',
    styleUrls: ['user-list.component.css'],
    moduleId: module.id
})
export class UserListComponent implements OnInit{
    users: any[];
    loading: boolean = true;
    accountRole = "";
    isSuper: boolean = false;

    constructor(
        private userService: UserService,
        private accountService: AccountService,
        private router: Router
    ) { };

    getUsers(): void {
        this.loading = true;
        this.accountService.getAccounts()
        .then(accounts => {
            this.accountService.users().then(users => {
                this.users = users.sort((a, b) => {
                    return a.localCompare(b);
                });
                this.loading = false;
            });
        });
    };

    ngOnInit(): void {
        this.isSuper = this.userService.isSuper;
        this.accountRole = this.userService.accountRole;
        if (this.accountRole === 'accountAdmin' || this.userService.isSuper) {
            this.getUsers();
        } else {
            this.loading = false;
        }
    };

    gotoDetail(user: User): void {
        this.router.navigate(['/users', user.id]);
    };

    getAccountName(user: User) {
        if (user.account) { return user.account.name; }
        return this.accountService.accountMap[user.accountId].name;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user-list/user-list.component.ts